import { Moon, Sun } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useTheme } from "@/lib/theme";

/**
 * Light/dark switch row. Rendered inside the agent footer menu — shows the
 * current theme label and toggles on click.
 */
export function ThemeToggle() {
  const { t } = useTranslation();
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      onClick={toggle}
      className="flex w-full items-center justify-between gap-2 rounded-md px-2.5 py-2 text-body text-body transition-colors hover:bg-hairline"
    >
      <span className="flex items-center gap-2">
        {isDark ? <Moon size={16} strokeWidth={2} /> : <Sun size={16} strokeWidth={2} />}
        {t("common.theme")}
      </span>
      <span className="text-label font-semibold text-muted">
        {isDark ? t("common.themeDark") : t("common.themeLight")}
      </span>
    </button>
  );
}
